import {IBannerVariables, IBannerVariablesState, VariablesType,} from "./types";
import {Reducer} from "redux";
import {union} from "lodash";
import {ActionType, getType} from "typesafe-actions";
import * as actions from './actions';
// @ts-ignore
import * as _ from 'lodash-es'
// @ts-ignore
import {filterDeep} from 'deepdash-es/standalone';
import {
    defaultBannerVariables,
    defaultChildDesignBannerVariables,
    defaultChildFeedBannerVariables,
    defaultMasterDesignBannerVariables,
    defaultMasterFeedBannerVariables
} from "./defaults";

export type BannerVariablesAction = ActionType<typeof actions>;


const initialBannerVariablesState: IBannerVariablesState = {
    bannerVariables: {
        byId: {
            // "master_design": defaultMasterDesignBannerVariables,
            // "child_design": defaultChildDesignBannerVariables,
            // "master_feed": defaultMasterFeedBannerVariables,
            // "child_feed": defaultChildFeedBannerVariables,
        },
    },
    activeDesignBannerVariables: defaultChildDesignBannerVariables,
    activeMasterDesignBannerVariables: defaultMasterDesignBannerVariables,
    activeFeedBannerVariables: defaultChildFeedBannerVariables,
    activeMasterFeedBannerVariables: defaultMasterFeedBannerVariables,
    isLoading: false
};

const loadNewBannerVariables = (value: IBannerVariables, state: IBannerVariablesState) => {
    return {
        ...state.bannerVariables,
        byId: {
            ...state.bannerVariables.byId,
            [value.id]: value
        },
    }
}


export const bannerVariablesReducer: Reducer<IBannerVariablesState, BannerVariablesAction> = (
    state = initialBannerVariablesState,
    action
) => {
    switch (action.type) {

        case getType(actions.fetchBannerVariablesByIdAsyncActions.request):
            return {
                ...state,
                isLoading: true
            };
        case getType(actions.fetchBannerVariablesByIdAsyncActions.success):
            return {
                ...state,
                isLoading: false,
                activeBannerVariables: action.payload.bannerVariables, // Todo fix
                bannerVariables: {
                    ...loadNewBannerVariables(action.payload.bannerVariables, state)
                }
            };
        case getType(actions.fetchBannerVariablesAsyncActions.request):
            return {
                ...state,
                isLoading: true,
            };
        case getType(actions.fetchBannerVariablesAsyncActions.success):
            const variablesList = action.payload.bannerVariablesList
            return {
                ...state,
                isLoading: false,
                bannerVariables: {
                    ...state.bannerVariables,
                    byId: {
                        ...state.bannerVariables.byId,
                        ...variablesList.byId
                    },
                }
            };
            /*
        case ADDING_NEW_BANNER_VARIABLES:
            return {
                ...state,
                activeBannerVariables: defaultBannerVariables
            };
             */
        case getType(actions.modifyingActiveBannerVariablesAction):
            const operation = (activeBannerVariables: IBannerVariables): IBannerVariables => {
                const active = _.merge({}, activeBannerVariables, action.payload.bannerVariables)
                if (action.payload.replace) {
                    active.variables = _.merge({}, action.payload.bannerVariables.variables)
                } else {
                    // @ts-ignore
                    active.variables = filterDeep(active.variables, (value: any, key: string, parent: any, context: any) => {
                        return !_.isNull(value);
                    }, {leavesOnly: true})
                }

                if (active.variables === null) {
                    active.variables = {}
                }
                return active
            }

            return {
                ...state,
                activeDesignBannerVariables: action.payload.variablesType === VariablesType.DESIGN ? operation(state.activeDesignBannerVariables) : state.activeDesignBannerVariables,
                activeFeedBannerVariables: action.payload.variablesType === VariablesType.FEED ? operation(state.activeFeedBannerVariables) : state.activeFeedBannerVariables,
            };
        case getType(actions.setMasterActiveBannerVariablesAction):
            return {
                ...state,
                activeMasterDesignBannerVariables: action.payload.variablesType === VariablesType.DESIGN ? action.payload.bannerVariables : state.activeMasterDesignBannerVariables,
                activeMasterFeedBannerVariables: action.payload.variablesType === VariablesType.FEED ? action.payload.bannerVariables : state.activeMasterFeedBannerVariables,
            }
        case getType(actions.saveBannerVariablesAsyncActions.request):
            return {
                ...state,
                isLoading: true
            };
        case getType(actions.saveBannerVariablesAsyncActions.success):
            return {
                ...state,
                isLoading: false,
                bannerVariables: {
                    ...loadNewBannerVariables(action.payload.bannerVariables, state)
                },
                activeDesignBannerVariables: action.payload.bannerVariables.variablesType === VariablesType.DESIGN ? action.payload.bannerVariables : state.activeDesignBannerVariables,
                activeFeedBannerVariables: action.payload.bannerVariables.variablesType === VariablesType.FEED ? action.payload.bannerVariables : state.activeFeedBannerVariables,
            };
        case getType(actions.deleteBannerVariablesAsyncActions.request):
            return {
                ...state,
                isLoading: true,
            };
        case getType(actions.deleteBannerVariablesAsyncActions.success):
            const {[action.payload.id]: removed, ...without} = state.bannerVariables.byId
            let active = defaultBannerVariables
            return {
                ...state,
                isLoading: false,
                bannerVariables: {
                    byId: without,
                },
                activeDesignBannerVariables: state.activeDesignBannerVariables.id === action.payload.id ? active : state.activeDesignBannerVariables,
                activeFeedBannerVariables: state.activeFeedBannerVariables.id === action.payload.id ? active : state.activeFeedBannerVariables,
            };

        case getType(actions.setActiveBannerVariablesByIdAction):
            let newActiveBannerVariables: IBannerVariables = defaultBannerVariables

            if (state.bannerVariables.byId[action.payload.id]) {
                newActiveBannerVariables = _.merge({}, state.bannerVariables.byId[action.payload.id])
            }
            let newActiveMasterBannerVariables: IBannerVariables = newActiveBannerVariables

            if (newActiveBannerVariables.parentId) {
                let parent = state.bannerVariables.byId[newActiveBannerVariables.parentId]
                if (parent) {
                    newActiveMasterBannerVariables = _.merge({}, parent)
                }
            }

            let activeVariables = {}
            if (action.payload.variablesType === VariablesType.DESIGN) {
                activeVariables = {
                    activeDesignBannerVariables: newActiveBannerVariables,
                    activeMasterDesignBannerVariables: newActiveMasterBannerVariables
                }
            } else if (action.payload.variablesType === VariablesType.FEED) {
                activeVariables = {
                    activeFeedBannerVariables: newActiveBannerVariables,
                    activeMasterFeedBannerVariables: newActiveMasterBannerVariables
                }
            }

            return {
                ...state,
                ...activeVariables
            }
        default:
            return state;
    }
};


